import {Component} from "react";
import React from "react";
import {PropTypes} from "prop-types";

const id = Math.random().toString();

class RatingScriptTag extends Component {
    componentDidMount() {
        const { src, token, userident, pageident } = this.props;

        const script = document.createElement("script");

        script.src = src;
        script.defer = true;
        script.type = "text/javascript";
        script.setAttribute("name", "ratesui");
        script.setAttribute("data-token", token);
        script.setAttribute("data-user-ident", userident);
        script.setAttribute("data-page-ident", pageident);

        const rdelm = document.getElementById(id);
        if (rdelm) {
            const pelm = rdelm.parentNode;
            if (pelm) {
               pelm.appendChild(script);
               pelm.removeChild(rdelm);
            } else {
               document.body.appendChild(script);
            }
         };
    }

    render() {
        return <span id={id} />
    }
}

RatingScriptTag.propTypes = {
    src: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    userident: PropTypes.string,
    pageident: PropTypes.string.isRequired
};
RatingScriptTag.defaultProps = {
    src: process.env.RATING_APIKEY,
    token: process.env.RATING_URL,
    userident: "",
    pageident: "window.location.pathname"
};

export default RatingScriptTag